import React from 'react';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Grid,
  IconButton,
  Tooltip,
} from '@mui/material';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers-pro/LocalizationProvider';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import TextField from '@mui/material/TextField';
import TablePagination from '@mui/material/TablePagination';
import ClearIcon from '@mui/icons-material/Clear';

const DetailedTable = ({
  userList,
  loading,
  value,
  search,
  setPage,
  page,
  setRowsPerPage,
  rowsPerPage,
  setValue,
  totalCount,
  handleSearchChange,
}) => {
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      {!loading ? (
        <>
          <TableContainer
            component={Paper}
            sx={{ minWidth: '80vw', maxHeight: '62vh', overflow: 'auto' }}
          >
            <Typography
              variant="h4"
              sx={{ fontWeight: 'bold', padding: '10px 22px' }}
            >
              {userList?.[0]?.user?.first_name} {userList?.[0]?.user?.last_name}
            </Typography>
            <Grid
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                padding: '0px 15px',
              }}
            >
              <Grid sx={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Box
                    sx={{
                      p: 2,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                    }}
                  >
                    <DateRangePicker
                      startText="Start"
                      endText="End"
                      value={value}
                      onChange={(newValue) => setValue(newValue)}
                      sx={{
                        width: '300px',
                      }}
                    />
                    {value[0] && value[1] && (
                      <Tooltip title="Clear Date Range Filter">
                        <IconButton
                          onClick={() => {
                            setValue([null, null]);
                            setPage(0);
                          }}
                        >
                          <ClearIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Box>
                </LocalizationProvider>
                <TextField
                  id="outlined-basic"
                  label="Search by email"
                  variant="outlined"
                  sx={{ width: '250px' }}
                  onChange={handleSearchChange}
                  value={search}
                />
              </Grid>
            </Grid>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={6}
                  >
                    <Box margin={1}>
                      <Table size="small" aria-label="purchases">
                        <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                              Email
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                              Status
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                              Sub Status
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                              Account
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                              Domain
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                              Domain Age Days
                            </TableCell>
                            <TableCell sx={{ fontWeight: 'bold' }}>
                              SMTP Provider
                            </TableCell>
                            <TableCell
                              align="right"
                              sx={{ fontWeight: 'bold' }}
                            >
                              Validated Time
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {userList.length > 0 ? (
                            userList.map((validated, index) => (
                              <TableRow key={index}>
                                <TableCell>
                                  {validated?.validationResponse?.address}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color:
                                      validated?.validationResponse?.status === 'valid'
                                        ? '#22C55E'
                                        : 'red',
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {validated?.validationResponse?.status}
                                </TableCell>
                                <TableCell>
                                  {validated?.validationResponse?.sub_status}
                                </TableCell>
                                <TableCell>
                                  {validated?.validationResponse?.account ||
                                    'Unknown'}
                                </TableCell>
                                <TableCell>
                                  {validated?.validationResponse?.domain ||
                                    'Unknown'}
                                </TableCell>
                                <TableCell>
                                  {validated?.validationResponse
                                    ?.domain_age_days || 'Unknown'}
                                </TableCell>
                                <TableCell>
                                  {validated?.validationResponse
                                    ?.smtp_provider || 'Unknown'}
                                </TableCell>
                                <TableCell align="right">
                                  {new Date(
                                    validated?.validatedAt,
                                  ).toLocaleString()}
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={8}
                                align="center"
                                sx={{ padding: 3 }}
                              >
                                This user has not validated any emails yet.
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <TablePagination
            rowsPerPageOptions={[10, 25,50, 100]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      ) : (
        <TableRow>
          <TableCell colSpan={8} align="center" sx={{ padding: 3 }}>
            This user has not validated any emails yet.
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default DetailedTable;
